import { ServiceProviderIdentifierType } from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';

export function getAuthorizedServiceProvidersState(
  serviceProviderIdentifierType: ServiceProviderIdentifierType
) {
  return serviceProviderIdentifierType ===
    ServiceProviderIdentifierType.LOGISTICS_PARTY_ID
    ? 'authorizedLps'
    : 'authorizedDSPs';
}
